module.exports = __webpack_public_path__ + "media/images/icons/outlined/history-a9140e7b4f7687133f4293e919d46698.svg";